export const STATUS_COLOR = {
  'annual leave': '#F6D0FE',
  'sick leave': '#B2DDFF',
  'other leave': '#F9DBAF',
  holiday: '#DDD6FE',
  weekend: '#D0D5DD',
  planned: '#AAF0C4',
  na: '#f0f0f0',
};

export const STATUS_BORDER_COLOR = {
  'annual leave': '#BA24D5',
  'sick leave': '#1570EF',
  'other leave': '#E04F16',
  holiday: '#7839EE',
  weekend: '#DADCE0',
  planned: '#099250',
};

export const leftColumns = [
  {
    header: 'Department',
    accessor: 'department',
    key: 'Dept',
    isBlank: true,
    width: '110px',
  },
  { header: 'Section', accessor: 'section', key: 'Section', width: '80px' },
  { header: 'Employee', accessor: 'employee', key: 'Name', width: '100px' },
];

export const leftHeadersLabels = {
  Dept: 'Department',
  Section: 'Section',
  Name: 'Employee',
};
